import { Button } from "antd";

export default function TableActions({
  onEdit,
  onDelete,
  showDelete = true
}: {
  onEdit: () => void;
  onDelete: () => void;
  showDelete?: boolean;
}) {
  return (
    <div className="flex gap-4">
      <Button type="link" className="w-9 p-0" onClick={onEdit}>
        Edit
      </Button>

      {showDelete ? (
        <Button type="link" className="w-12 p-0" onClick={onDelete}>
          Delete
        </Button>
      ) : null}
    </div>
  );
}
